import axios from "axios";
import { useQuery } from "react-query";
import { getHeader } from "../utils/util";

const useGetCount = (path) => {
  return useQuery({
    queryKey: [path],
    queryFn: async () => {
      const response = await axios.get(path, getHeader());
      return response.data;
    },

    retry: (failureCount, error) => {
      if (!error.response) return true; // Retry on network errors
      const status = error.response.status;
      return status !== 401 && status !== 404 && status !== 500; // No retries for 404/500
    },
  });
};

export default useGetCount;
